import { render } from "./DoublePie.vue?vue&type=template&id=62a3fa5e&scoped=true"
import script from "./DoublePie.vue?vue&type=script&lang=js"
export * from "./DoublePie.vue?vue&type=script&lang=js"

import "./DoublePie.vue?vue&type=style&index=0&id=62a3fa5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a3fa5e"]])

export default __exports__